import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CheckListsPageComponent } from './components/check-lists-page/check-lists-page.component';
import { CHECK_LISTS_PATHS } from './check-lists';
import { AuthGuard } from '../auth/auth.guard.service';

const routes: Routes = [
  {
    path: CHECK_LISTS_PATHS.checkLists,
    component: CheckListsPageComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: CHECK_LISTS_PATHS.reporting,
        loadChildren: () => import('./modules/reporting/reporting.module').then((m) => m.ReportingModule),
      },
      {
        path: CHECK_LISTS_PATHS.composing,
        loadChildren: () => import('./modules/check-lists/check-lists.module').then((m) => m.CheckListsModule),
      },
      {
        path: CHECK_LISTS_PATHS.reporting_grrs,
        loadChildren: () => import('./modules/reporting-grrs/reporting-grrs.module').then((m) => m.ReportingGrrsModule),
      },
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CheckListsPageRoutingModule {}
